// import { LockIcon } from 'components/icons'
// import ElementTooltip from './Tooltip'
import { Text } from './Text'
// import { Button } from './Button'
// import { SvgWrap } from 'components/svg'
import { useTranslation } from 'react-i18next'
// import { Button } from './Button'
// import { SvgWrap } from 'components/svg'
// import { LockIcon } from 'components/icons'

export const LockTooltip = () => {
  const { t } = useTranslation()
  return (
    <>
      <Text as="tooltip" color="white">
        {t('no_permission_access')}
      </Text>
      {/* <ElementTooltip
        // children={
        //   <Button transparent="asIconGray">
        //     <SvgWrap color={'disabled'} size={'xxs'}>
        //       <LockIcon />
        //     </SvgWrap>
        //   </Button>
        // }
        // children={

        // }
        title={
          <>
            <Text as="tooltip" color="white">
              {t('no_permission_access')}
            </Text>
          </>
        }
        placement="top"
      >
        <Button transparent="asIconGray">
          <SvgWrap color={'disabled'} size={'xxs'}>
            <LockIcon />
          </SvgWrap>
        </Button>
      </ElementTooltip> */}
    </>
  )
}
